//@flow

import React, { Fragment } from 'react';
import Rater from 'react-rater';
import isEmpty from 'lodash/isEmpty';
import capitalize from 'lodash/capitalize';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import makeUrl from '../../../lib/makeUrl';
import endpoints from '../../../lib/endpoints';
import type { Lodge } from '../utils';
import EditableInput from '../../../components/EditableInput';
import { isSuperUser } from '../../../lib/utils';
import getAverage from '../../../components/ReviewsRatings/utils';
import { constructTitle } from '../helpers';

type Props = {
  lodgeDetail: Lodge,
  onBookClick: () => void,
  numberOfReviews: number,
  numberOfRatings: null | number,
};

const capitalizedText = { textTransform: 'capitalize' };

const BasicInformation = ({
  lodgeDetail: {
    name,
    address,
    region,
    phoneNumbers,
    email,
    id: lodgeId,
    place,
    isBookable,
    startingPrice,
  },
  onBookClick,
  numberOfRatings,
  numberOfReviews,
}: Props) => {
  const { amount } = startingPrice || { amount: 0 };
  return (
    <Fragment>
      {name && (
        <div className="lodge-detail"  id="sd-lodge-name" data-lodge-name={name} >
          <div id="sd-lodge-price" data-lodge-price={amount}>
            {isSuperUser() ? (
              <EditableInput
                className="value"
                patchKey="name"
                value={name ? capitalize(name) : ''}
                endpoint={endpoints.lodge.editData(lodgeId)}
              >
                <div className="value" >{capitalize(name)}</div>
              </EditableInput>
            ) : (
              <h1>
                {capitalize(name)}
                <span>
                  <Rater total={5} rating={numberOfRatings} interactive={false} />
                  <span>({numberOfReviews} Review{numberOfReviews > 1 ? 's' : ''})</span>
                </span>
              </h1>
            )}
            <ul>
              <li>
                {address && (
                  <span style={capitalizedText}>
                    <Link to={makeUrl.placeDetails(address, place.id, region)}>
                      {address}
                    </Link>
                  </span>
                )}
                {address && region && <span>,</span>}{' '}
                {region && (
                  <span
                    style={capitalizedText}
                    id="sd-lodge-description"
                    data-lodge-description={constructTitle({ name, address, region })}
                  >
                    <a href={makeUrl.goToRegionInfo(region)}>
                      {region} Region
                    </a>
                  </span>
                )}
              </li>
  
              {!isEmpty(phoneNumbers) && (
                <li>
                  {phoneNumbers.map((num, idx, arr) => {
                    const lastNumberInArr = arr.length - 1 === idx;
                    return (
                      <a href={`tel:${num}`} key={num}>
                        +977-{num}
                        {lastNumberInArr ? '' : ','}{' '}
                      </a>
                    );
                  })}
                </li>
              )}
  
              {email && (
                <li>
                  <i className="icon icon-hg-email-opened-envelope" />
                  <a href={`mailto:${email}`}>{email}</a>
                </li>
              )}
            </ul>
          </div>
  
          {isBookable && (
            <div>
              <Button className="btn btn-yellow" onClick={onBookClick} id="lodges-add-to-cart-btn">
                Add to Cart
              </Button>
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
}

const mapStateToProps = ({ reviewsState: { reviews }, ratingsState: { ratings } }) => ({
  numberOfReviews: isEmpty(reviews) ? 0 : reviews.length,
  numberOfRatings: getAverage(ratings),
});

export default withRouter(connect(mapStateToProps)(BasicInformation));



// WEBPACK FOOTER //
// ./src/screens/Lodge/Details/BasicInformation.js